<template>
  <ul>
    <li
      @click="onClick()"
    >
      <router-link to="/devices">
        Devices
      </router-link>
    </li>
    <li
      v-if="$store.getters.isOrgAdminAccess"
      class="drop-down-nav"
      @click="onClick()"
    >
      <div class="d-none d-lg-inline-block">
        <router-link to="/organizations">
          Organization{{ $store.getters.isKgbAdminUser ? 's' : '' }}
          <span>
            <font-awesome-icon
              :icon="['fas', 'chevron-down']"
              class="icon alt"
            />
          </span>
        </router-link>
      </div>
      <ul class="sub-menu">
        <li
          @click="onClick()"
        >
          <router-link to="/sites">
            Sites
          </router-link>
        </li>
      </ul>
    </li>
    <li
      v-if="$store.getters.isAdminUser"
      @click="onClick()"
    >
      <router-link to="/users">
        Users
      </router-link>
    </li>
    <li
      v-if="$store.getters.isAdminUser"
      @click="onClick()"
    >
      <router-link to="/reporting">
        Reporting
      </router-link>
    </li>
    <li
      v-if="$store.getters.isAdminUser"
      @click="onClick()"
    >
      <router-link to="/usage">
        Usage
      </router-link>
    </li>
    <li
      v-if="$store.getters.isAdminUser
        || canSeeTestFixture"
      class="drop-down-nav"
    >
      <div class="d-none d-lg-inline-block">
        Maintenance
        <span>
          <font-awesome-icon
            :icon="['fas', 'chevron-down']"
            class="icon alt"
          />
        </span>
      </div>
      <ul class="sub-menu">
        <li
          v-if="$store.getters.isAdminUser"
          @click="onClick()"
        >
          <router-link to="/testResults">
            DART Test Results
          </router-link>
        </li>
        <li
          v-if="canSeeTestFixture"
          @click="onClick()"
        >
          <router-link to="/testFixtures">
            Test Fixtures
          </router-link>
        </li>
        <li
          v-if="canSeeTestFixture"
          @click="onClick()"
        >
          <router-link to="/testFixtureResults">
            Cable Test Results
          </router-link>
        </li>
      </ul>
    </li>

    <li
      v-if="$store.getters.isKgbAdminUser
        && $store.getters.currentUser.allowed_to_access_management"
      @click="onClick()"
    >
      <router-link to="/management">
        Management
      </router-link>
    </li>
    <li
      v-if="$store.getters.isAuthorized"
      class="d-lg-none"
      @click="onClick()"
    >
      <router-link to="/account">
        My Account
      </router-link>
    </li>
    <li
      v-if="$store.getters.isAuthorized"
      class="d-lg-none"
      @click="onClick()"
    >
      <router-link to="/updatePassword">
        Update Password
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'NavigationMenu',
  props: {
    onClick: {
      type: Function,
      default: () => {
      },
    },
  },
  computed: {
    canSeeTestFixture() {
      return this.$store.getters.showTestFixture;
    },
  },
};
</script>

<style lang="scss" scoped>
.drop-down-nav {
  user-select: none;

  div {
    display: inline-block;
    vertical-align: top;

    span {
      display: inline-block;
      margin-left: 8px;
      font-size: 10px;
      vertical-align: middle;
    }
  }

  &:hover {
    ul.sub-menu {
      display: block !important;
    }
  }

  ul.sub-menu {
    display: none !important;

    @media (max-width: $lg-min) {
      display: block !important;
    }
  }

  @media (min-width: $lg-min) {
    &:hover {
      div {
        color: lighten($blue, 5%);

        span {
          color: rgba(0, 0, 0, 0.67);
        }
      }

      ul {
        @include border-radius($border-radius);

        position: absolute;
        display: block;
        padding: 0;
        background: white;
        border: solid 1px #ddd;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
        0 6px 6px rgba(0, 0, 0, 0.23);

        li {
          display: block;
          width: 100%;
          padding: 0;

          a {
            display: block;
            width: 100%;
            padding: 5px 20px;
            color: rgba(0, 0, 0, 0.67);
            white-space: nowrap;

            &:hover {
              color: $blue;
              background: #fafafa;
            }
          }
        }
      }
    }
  }
}
</style>
